<!-- eslint-disable pct-custom-ng-rules/no-mat-icon-svg-icon -->
<button class="close-button" type="button" (click)="closeElement.emit()">
  <mat-icon svgIcon="pct-mdi-close" />
</button>
@if (loading()) {
  <mat-spinner class="!inline-block mr-2" diameter="40" />
} @else if (notifications === null || notifications.length === 0) {
  <p class="m-4">Nincsenek értesítések</p>
} @else {
  @for (n of notifications; track n.notificationId) {
    <div class="notification" fadeIn2XFastEnter>
      <div class="heading">
        <h3>{{ n.title }}</h3>
        <button type="button" [disabled]="n.loading" (click)="deleteNotification(n)">
          @if (n.loading) {
            <mat-spinner class="!inline-block mr-2" diameter="20" />
          } @else {
            <mat-icon svgIcon="pct-mdi-delete-forever" />
          }
        </button>
      </div>
      <p>{{ n.description }}</p>
    </div>
  }
}
